import useSubscriptionPermission from "@/hooks/useSubscriptionPermission";
import usePaywall from "@hooks/usePaywall";
import clsx from "clsx";
import { RecipeContext } from "contexts/RecipeContext";
import { useStores } from "hooks/useStores";
import { observer } from "mobx-react";
import React, { useContext, useState } from "react";
import { useInterval } from "react-use";

const ANIMATE_EVERY = 30 * 1000;
const ANIMATION_DURATION = 1000;

const ActivateRecipe = observer(({ recipe }) => {
  const { authStore } = useStores();
  const { setPaywall } = usePaywall();
  const { setActiveRecipe, setActiveStepIndex } = useContext(RecipeContext);
  const { subscriptionPermission } = useSubscriptionPermission(recipe);
  const [pulse, setPulse] = useState(false);

  const activateRecipe = () => {
    setActiveRecipe(recipe);

    // Need to calculate the first actual step
    setActiveStepIndex(0);
  };

  const handleClick = () => {
    if (
      authStore.currentUser &&
      subscriptionPermission.canUseRecipeStepByStep
    ) {
      activateRecipe();
    } else {
      setPaywall({
        isOpen: true,
        isClosable: true,
        variant: "learnStepByStep",
        title: recipe.title,
      });
    }
  };

  const setPulseThenUnset = () => {
    setPulse(true);
    setTimeout(() => {
      setPulse(false);
    }, ANIMATION_DURATION);
  };

  // Re-render component every second
  useInterval(() => {
    setPulseThenUnset();
  }, ANIMATE_EVERY);

  const className = clsx("ActivateRecipe", {
    "ActivateRecipe--animation--pulse": pulse,
  });

  return (
    <div className={className}>
      <button
        className="ActivateRecipe__button"
        onClick={handleClick}
        type="button"
        data-recipe-id={recipe.id}
        data-recipe-title={recipe.title}
        aria-label="Activate step-by-step"
      >
        <div className="ActivateRecipe__label">Go</div>
      </button>
      <div className={clsx("ActivateRecipe__content", "body-text-sm")}>
        Press <strong>GO</strong> to start step-by-step mode and keep your
        screen awake as you cook.
      </div>
    </div>
  );
});

export default ActivateRecipe;
